var Acr = Acr || {};

/**
  * @desc Gets the Trim Package Names info from window.Acr.TrimPackageNamesData
*/
Acr.TrimPackageNames = (function () {
  function getTrimPackageName(modelId) {
    return Acr.TrimPackageNamesData[modelId] || '';
  }

  return {
    getTrimPackageName: getTrimPackageName,
  };

}());
